<template>
    <div class="device-info">
        <v-list dense>
            <v-subheader>Device Info</v-subheader>
            <div class="tiny-text">
            <v-list-tile>
                <v-list-tile-content>
                        {{ device && device.opened ? 'Connected' : 'Disconnected' }}
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon :color="device && device.opened ? 'green' : 'red'" small>usb</v-icon>
                </v-list-tile-action>
            </v-list-tile>
            <v-divider/>
            <v-list-tile>
                <v-list-tile-content>
                    {{ device ? `${device.manufacturerName} ${device.productName}`  : '-' }}
                </v-list-tile-content>
            </v-list-tile>
            <v-divider/>
            <v-list-tile>
                <v-list-tile-content>
                    Device ID: {{ deviceId || '-' }}
                </v-list-tile-content>
            </v-list-tile>
            <v-divider/>
            <v-divider/>
            <v-list-tile>
                <v-list-tile-content>
                    USB Version:&nbsp;
                    {{ device ? `${device.usbVersionMajor}.${device.usbVersionMinor}.${device.usbVersionSubminor}` : '-' }}
                </v-list-tile-content>
            </v-list-tile>
            </div>
        </v-list>
    </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "device-info",
  computed: {
    ...mapState(["device", "deviceId"])
  }
};
</script>
<style>
.device-info {
  height: 245px;
  overflow: hidden;
}
.list--dense .tiny-text .list__tile {
  font-size: 10px !important;
}
</style>
